import React from "react";
import SEO from "../../components/SEO";

const BestSunglasses = () => {
  return (
    <div>
      <SEO 
        title="Best Sunglasses Under ₹999 in India (2026)"
        description="Discover the best affordable sunglasses in India with UV protection and stylish designs."
      />

      <h1>Best Sunglasses Under ₹999 in India</h1>

      <p>
        Looking for stylish and affordable sunglasses in India? Mark & Luth offers premium designs with UV protection at budget-friendly prices.
      </p>

    </div>
  );
};

export default BestSunglasses;